<template>
  <!--更换验证手机号-身份验证-->
  <el-dialog
    :title="layerTitle"
    :visible.sync="changePhoneVerifyDialog"
    width="35%"
    custom-class="MyDialog"
    append-to-body
    @close="cancelReplaceNewPhone"
    >
    <el-form ref="form" :model="changePhoneVerifyFrom" label-width="100px">
      <el-form-item :label="$t('app.label')">
        <el-input
          :style="{
            width: '60%'
          }"
          v-model="phoneCheckInfoObj.username"
          :placeholder="$t('app.pleaseEnter')"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <!--原手机号-->
      <el-form-item v-if="isStateNum == 1" :label="$t('app.label')">
        <el-input
          :style="{
            width: '60%'
          }"
          v-model="phoneCheckInfoObj.phone"
          :placeholder="$t('app.pleaseEnter')"
          :disabled="true"
        ></el-input>
        <el-button
          type="text"
          :disabled="codeCountDown >= 0"
          @click="getPhoneCode"
          :style="{
            color: 'rgb(24, 144, 255)',
            marginLeft: '20px'
          }"
        >
          <span v-if="!isSendCode">{{ $t('app.auto_271_2d5d3117') }}</span>
          <span
            :style="{
              color: 'rgb(192, 192, 192)'
            }"
            v-if="codeCountDown >= 0"
            >{{ codeCountDown }}s后重新获取</span
          >
          <span v-if="codeCountDown < 0 && isSendCode">{{ $t('app.auto_272_4a32ae17') }}</span>
        </el-button>
      </el-form-item>
      <!--新原手机号-->
      <el-form-item v-if="isStateNum == 2" :label="$t('app.label')">
        <el-input
          :style="{
            width: '60%'
          }"
          v-model="changePhoneVerifyFrom.newPhone"
          :placeholder="$t('app.pleaseEnter')"
          oninput="if(value.length>11){value=value.slice(0,11)}"
        ></el-input>
        <el-button
          type="text"
          :disabled="codeCountDown >= 0"
          @click="getPhoneCode"
          :style="{
            color: 'rgb(24, 144, 255)',
            marginLeft: '20px'
          }"
        >
          <span v-if="!isSendCode">{{ $t('app.auto_269_def5443e') }}</span>
          <span
            :style="{
              color: 'rgb(192, 192, 192)'
            }"
            v-if="codeCountDown >= 0"
            >{{ codeCountDown }}s后重新获取</span
          >
          <span v-if="codeCountDown < 0 && isSendCode">{{ $t('app.auto_270_57fefe83') }}</span>
        </el-button>
      </el-form-item>
      <el-form-item :label="$t('app.label')">
        <el-input
          :style="{
            width: '60%'
          }"
          v-model="changePhoneVerifyFrom.phoneCode"
          :placeholder="$t('app.pleaseEnter')"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelReplaceNewPhone">取 消</el-button>
      <el-button type="primary" @click="submitChangePhone">{{ isStateNum == 1 ? this.$t('app.auto_668_728b44d2') : this.$t('app.auto_669_6e573553') }}</el-button>
    </span>
  </el-dialog>  
</template>

<script>
import { getPhoneCode ,checkPhoneCode, checkValidCode } from '@/api/AccountSetting';  //获取短信验证码，绑定手机号

export default {
  data() {
    return {
      changePhoneVerifyDialog: false, // 更换验证手机号-身份验证
      changePhoneVerifyFrom: {
        oldPhone: "",
        newPhone: "",
        loginAccount: '',
        phoneCode: ""
      },
      isSendCode: false,
      codeCountDown: -1,
    }
  },
  props: {
    phoneCheckInfoObj: {
      type: Object,
      default: () => {},
    },
    isStateNum: {
      type: Number,
      default: 1
    },
    layerTitle: {
      type: String,
      default: '',
    },
    isShowOpen: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    isShowOpen: {
      handler(newVal, oldVal) {
        console.log('--323232323');
        this.changePhoneVerifyDialog = newVal
      },
      immediate: true
    },
    codeCountDown(newValue, oldValue) {
      if (newValue === 60) {
        this.codeTimeKeep();
      }
    }
  },
  methods: {
    // 更换手机-获取验证码
    getPhoneCode() {
      let phone = '';
      if (this.isStateNum == 1) {
        phone = this.phoneCheckInfoObj.phone;
        if (!phone) {
          this.$message.error(this.$t('app.pleaseEnterPhone'));
          return;
        }
      } else {
        phone = this.changePhoneVerifyFrom.newPhone;
        if (!phone) {
          this.$message.error(this.$t('app.pleaseEnterPhone'));
          return;
        }
      }
      
      let params = {
        mobile: phone
      };
      getPhoneCode(params).then(ret => {
        if (ret.code === 0) {
          this.$message.success(this.$t('message.codeSentTip'));
          this.codeCountDown = 60;
          this.isSendCode = true;
        }
      });
    },
    codeTimeKeep() {
      this.codeTimer = setInterval(() => {
        if (this.codeCountDown < 0) {
          clearInterval(this.codeTimer);
          return;
        }
        this.codeCountDown -= 1;
      }, 1000);
    },
    resetTimer() {
      if (this.codeTimer) {
        clearInterval(this.codeTimer);
      }
      this.codeCountDown = -1;
      this.isSendCode = false;
    },
    submitChangePhone() {
      // let params ={
      //   "phoneCode": this.changePhoneVerifyFrom.phoneCode,                //类型：String  必有字段  备注：验证码
      // }

      // if (this.isStateNum == 1) {
      //   params['phone'] = this.phoneCheckInfoObj.phone;
      // } else {
      //   if (!this.changePhoneVerifyFrom.newPhone) {
      //     this.$message.error(this.$t('app.pleaseEnterNewPhone'));
      //     return;
      //   }
      //   params['phone'] = this.changePhoneVerifyFrom.newPhone;
      // }
      // checkPhoneCode(params).then(ret=>{
      //   if(ret.code === 0){
      //     this.$message({
      //       message: ret.message || "验证成功",
      //       type: 'success'
      //     });
      //     this.verifyMessage();
      //   }
      //   else {
      //     this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || "验证失败");
      //   }
      // })
      this.verifyMessage();
    },
    // 提交信息
    async verifyMessage() {
      if (this.isStateNum == 1 && this.phoneCheckInfoObj.phone == "") {
        this.$message.error(this.$t('app.pleaseEnterOriginalPhone'));
        return;
      }

      if (this.isStateNum == 2 && this.changePhoneVerifyFrom.newPhone == "") {
        this.$message.error(this.$t('app.pleaseEnterNewPhone'));
        return;
      }

      if (this.changePhoneVerifyFrom.phoneCode == "") {
        this.$message.error(this.$t('app.pleaseEnterVerifyCode'));
        return;
      }

      if (this.isStateNum == 1) {
        let params = {
          phoneNo: this.phoneCheckInfoObj.phone,
          code: this.changePhoneVerifyFrom.phoneCode
        }
        await checkValidCode(params).then(res=>{
          if(res.code === 0){
            this.resetTimer()
            this.changePhoneVerifyFrom.phoneCode = '';
            this.$emit('changeNewPhone');
          }else{
            this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs) || this.$t('app.auto_670_c8e36f07'));
          }
         })
      } else {
        let params = {
          phoneNo: this.changePhoneVerifyFrom.newPhone,
          code: this.changePhoneVerifyFrom.phoneCode
        }
        await checkValidCode(params).then(res=>{
          if(res.code === 0){
            this.resetTimer();
            let params = {
              newMobile: this.changePhoneVerifyFrom.newPhone,//新手机号
              newMobileCode: this.changePhoneVerifyFrom.phoneCode,//新手机号验证码
              oldMobile: this.phoneCheckInfoObj.phone //旧手机号
            }
            this.$emit('verifyNewPhoneLogin', params);
          }else{
            this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs) || this.$t('app.auto_671_29db97da'));
          }
         })
      }
    },
    cancelReplaceNewPhone() {
      this.changePhoneVerifyDialog = false;
      this.resetTimer();
      this.$emit('closeReplaceYouPhone');
    }
  },
}
</script>

<style>

</style>